<div class="gt-page-header">
  <h1><i class="fa fa-life-ring"></i> {{ pageTitle }}</h1>
</div>

<div class="panel panel-default help-panel">
  <div class="panel-heading">Client Support :</div>
  <div class="panel-body">
    <div>
      Users can raise a question with support team or report a possible issue for the GTW
      application by using IST client support portal
    </div>
    <button class="btn btn-warning btn-xs linkBtn" type="button">
      <a class="supportLink" [href]="supportURL" target="_blank">Client Support</a>
    </button>
  </div>
</div>

<gtw-release-notes-ce
  capture-custom-events>
</gtw-release-notes-ce>
